import LoaderHelper from './loader-helper';

const loader = new LoaderHelper();

export { default as LoaderManager } from './loader-manager';
export default loader;
